import { render, staticRenderFns } from "./ColorSettings.vue?vue&type=template&id=069a6398&"
import script from "./ColorSettings.vue?vue&type=script&lang=js&"
export * from "./ColorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports